/**
 * Recently viewed products — tracks product handles in localStorage and
 * renders cards via Shopify's /products/{handle}.js endpoint.
 *
 * - On PDPs: pushes the current handle into the list, dedupes, caps to 24
 * - On any page with `[data-recently-viewed]`: renders the previous N items
 *   (excluding the current product if on a PDP) using a <template> cloning
 *   pattern. Section stays `hidden` until at least 1 item resolves.
 *
 * Storage key is namespaced by shop to avoid collisions across multi-shop
 * Chrome profiles.
 */
(function () {
  const KEY = `medcline-eu:recently-viewed`;
  const MAX_STORED = 24;
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
  });

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch { /* quota / privacy mode — ignore */ }
  }
  function pushHandle(handle) {
    if (!handle) return;
    const list = load().filter((h) => h !== handle);
    list.unshift(handle);
    save(list.slice(0, MAX_STORED));
  }

  // Pickup the current handle on PDP load
  const sections = document.querySelectorAll('[data-recently-viewed]');
  sections.forEach((s) => {
    const handle = s.dataset.currentHandle;
    if (handle) pushHandle(handle);
  });

  // Render
  sections.forEach((section) => renderInto(section));

  async function renderInto(section) {
    const grid = section.querySelector('[data-rv-grid]');
    const tpl = section.querySelector('[data-rv-template]');
    if (!grid || !tpl) return;

    const currentHandle = section.dataset.currentHandle;
    const max = Number(section.dataset.maxItems) || 6;
    const handles = load().filter((h) => h !== currentHandle).slice(0, max);

    if (handles.length === 0) return; // keep section hidden

    const results = await Promise.all(handles.map(fetchProduct));
    const products = results.filter(Boolean);
    if (products.length === 0) return;

    products.forEach((p) => grid.appendChild(renderCard(tpl, p)));
    section.hidden = false;
  }

  async function fetchProduct(handle) {
    try {
      const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      return r.json();
    } catch {
      return null;
    }
  }

  function renderCard(tpl, p) {
    const node = tpl.content.firstElementChild.cloneNode(true);
    const link = node.querySelector('[data-rv-url]');
    link.href = p.url;
    const img = node.querySelector('[data-rv-image]');
    if (img && p.featured_image) {
      img.src = p.featured_image.replace('.jpg', '_400x500.jpg').replace('.png', '_400x500.png');
      img.alt = p.title;
    }
    node.querySelector('[data-rv-title]').textContent = p.title;
    const price = node.querySelector('[data-rv-price]');
    if (price && p.price != null) price.textContent = formatter.format(p.price / 100);
    return node;
  }
})();
